import { uniq } from 'lodash';
import { useSelector } from 'react-redux';
import useCreateTempDashboard from './useCreateTempDashboard';
import { getFirstAppliedFilter } from '@src/store/common/selectors';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';

function useDiagDashboard({
  metrics,
  defaultMetric = null,
  title,
  usecaseKey,
  widgetMeta = {},
  selectedDimensions,
  selectedUnit,
  filter,
}: {
  metrics: string[];
  title: string;
  usecaseKey?: string;
  widgetMeta?: Record<string, any>;
  defaultMetric?: null | string;
  selectedDimensions?: string[];
  selectedUnit?: '#' | '%' | '%T';
  filter?: any;
}) {
  const selectedMetric = defaultMetric ? defaultMetric : metrics[0];
  const appliedFilter = useSelector(getFirstAppliedFilter);

  const { createDashboard } = useCreateTempDashboard({
    filter: filter || appliedFilter,
    metrics: uniq(
      metrics.map((m) =>
        getInvertedPercentageMetricByKey({
          metricKey: m,
          defaultValue: m,
        }),
      ),
    ),
    selectedMetric: getInvertedPercentageMetricByKey({
      metricKey: selectedMetric,
      defaultValue: selectedMetric,
    }),
    title,
    selectedDimensions,
    selectedUnit,
    usecaseKey,
    widgetMeta,
  });

  return { createDashboard };
}

export default useDiagDashboard;
